import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { medicationsClassificationActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = medicationClassification => {
    const {
      onClose,
      addMedicationClassification,
      editMedicationClassification,
      changeMessage
    } = this.props

    if (medicationClassification._id) {
      editMedicationClassification(medicationClassification).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addMedicationClassification(medicationClassification).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, medicationClassification) => {
    e.preventDefault()
    const { setMedicationClassificationFormTouched } = this.props

    if ((this.props.medicationClassificationFormErrors || {}).valid) {
      this.handleSave(medicationClassification)
    } else {
      setMedicationClassificationFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      medicationClassification = {},
      handleChangeMedicationClassification,
      loadingMedicationClassification,
      medicationClassificationFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('classificacoes_medicamentos', token)

    return (
      <div>
        <Dialog
          modalId={medicationClassification._id ? 'classificacoes-medicamentos-editar' : 'classificacoes-medicamentos-nova'}
          modalParams={{ registro: medicationClassification._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingMedicationClassification ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(medicationClassification._id ? 'classificacoes-medicamentos-editar' : 'classificacoes-medicamentos-nova') + '-title'}>
                {isReadOnly ? (
                  'Classificações de Medicamentos'
                ) : (
                  <Fragment>
                    {medicationClassification._id
                      ? 'Editar classificação'
                      : 'Cadastrar classificação'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'medicationClassification-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, medicationClassification)
                  }}
                >
                  <FormControl
                    error={
                      !((medicationClassificationFormErrors.fields || {})['nome'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Classificação</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeMedicationClassification({
                          ...medicationClassification,
                          nome: e.target.value
                        })
                      }}
                      value={medicationClassification.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((medicationClassificationFormErrors.fields || {})['nome'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((medicationClassificationFormErrors.fields || {})['nome'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'medicationClassification-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    medicationClassification: state.medicationClassification.medicationClassification,
    loadingMedicationClassification: state.medicationClassification.loadingMedicationClassification,
    medicationClassificationFormErrors:
      state.medicationClassification.medicationClassificationFormErrors,
    formTouched: state.medicationClassification.medicationClassificationFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsClassificationActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsClassificationActions.closeModal())
    },
    handleChangeMedicationClassification: medicationClassification => {
      dispatch(
        medicationsClassificationActions.handleChangeMedicationClassification(
          medicationClassification
        )
      )
    },
    addMedicationClassification: medicationClassification => {
      return dispatch(
        medicationsClassificationActions.addMedicationClassification(medicationClassification)
      )
    },
    editMedicationClassification: medicationClassification => {
      return dispatch(
        medicationsClassificationActions.editMedicationClassification(medicationClassification)
      )
    },
    setMedicationClassificationFormTouched: medicationClassification => {
      dispatch(medicationsClassificationActions.setMedicationClassificationFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/MedicationClassification/EditModal.js